import { render, staticRenderFns } from "./ClassIIMedical-rejectList.vue?vue&type=template&id=2dd4cb48&scoped=true&"
import script from "./ClassIIMedical-rejectList.vue?vue&type=script&lang=js&"
export * from "./ClassIIMedical-rejectList.vue?vue&type=script&lang=js&"
import style0 from "./ClassIIMedical-rejectList.vue?vue&type=style&index=0&id=2dd4cb48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4cb48",
  null
  
)

export default component.exports